import { render, staticRenderFns } from "./EodClosingSummaryBar.vue?vue&type=template&id=28601f02&scoped=true&"
import script from "./EodClosingSummaryBar.vue?vue&type=script&lang=js&"
export * from "./EodClosingSummaryBar.vue?vue&type=script&lang=js&"
import style0 from "./EodClosingSummaryBar.vue?vue&type=style&index=0&id=28601f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28601f02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
